module.exports = __webpack_public_path__ + "img/PD1505109162814734336.dff99a2e.png";